import { A7PageSizeMatcher } from '@ark7/layout';
import { Component } from '@angular/core';

@Component({
    selector: 'app-andes-customer-relationship-summary',
    templateUrl: './andes-customer-relationship-summary.component.html',
    styleUrls: ['./andes-customer-relationship-summary.component.scss'],
    standalone: false
})
export class AndesCustomerRelationshipSummaryComponent {
  @A7PageSizeMatcher('SM-') sm;
}
